import { createAction, props } from "@ngrx/store";
import { Building } from "src/components/shared-components/class/general-classes/building";
import { BuildingStoreAction } from "src/components/shared-components/enum/enumStoreAction";

/**
 * Action add building
 */
export const buildingAddAction = createAction(
  BuildingStoreAction.ADD_BUILDING,
  props<{ newBuilding: Building }>()
);

/**
 * Action update building
 */
export const buildingUpdateAction = createAction(
  BuildingStoreAction.UPDATE_BUILDING,
  props<{ updateBuilding: Building }>()
);

/**
 * Action remove building
 */
export const buildingRemoveAction = createAction(
  BuildingStoreAction.REMOVE_BUILDING,
  props<{ idBuilding: number }>()
);

export const buildingChangeWanAllowConnectionAction = createAction(
  BuildingStoreAction.CHANGE_WAN_CONNECTION_FLAG,
  props<{ idBuilding: number; allowWanConnection: boolean }>()
);

/**
 * Update building list with default supervision list to open
 */
export const buildingefaultSupervisionToOpenAction = createAction(
  BuildingStoreAction.CHANGE_BUILDING_DEFAULT_SUPERVISION_TO_OPEN,
  props<{ idBuilding: number; idSupervision: number; idEnvironment: number }>()
);

//#region  Current building Actions
/**
 * Change current building selection
 */
export const currentBuildingChangeSelectionAction = createAction(
  BuildingStoreAction.SELECTED_BUILDING_CHANGED,
  props<{ selectedBuilding: Building; defaultBuilding: boolean }>()
);

/**
 * Action to unset current building
 */
export const currentBuildingUnsetAction = createAction(
  BuildingStoreAction.SELECTED_BUILDING_UNSET
);

/**
 * Change current building connection address
 */
export const currentBuildingChangeConnectionAddressAction = createAction(
  BuildingStoreAction.SELECTED_BUILDING_CHANGE_CONNECTION_ADDREESS,
  props<{ newAddressConnection: string }>()
);

/**
 * Change current building connection address
 */
export const currentBuildingChangeWanConnectionAction = createAction(
  BuildingStoreAction.SELECTED_BUILDING_CHANE_WAN_CONNECTION_FLAG,
  props<{ allowWanConnection: boolean }>()
);

/**
 * Set current building defualt supervision to open
 */
export const currentBuildingChangeDefaultSupervisionToOpenAction = createAction(
  BuildingStoreAction.SELECTED_BUILDING_CHANGE_DEFAULT_SUPERVISION_TO_OPEN,
  props<{ idSupervision: number; idEnvironment: number }>()
);

/**
 * Action overwrite building
 */
export const buildingOverwriteAction = createAction(
  BuildingStoreAction.OVERWRITE_BUILDING,
  props<{ updateBuildings: Array<Building> }>()
);
//#endregion
